const storageSources = () => {
  const stores = [];
  if (typeof window !== "undefined") {
    if (window.localStorage) stores.push(window.localStorage);
    if (window.sessionStorage) stores.push(window.sessionStorage);
  } else {
    if (typeof localStorage !== "undefined") stores.push(localStorage);
    if (typeof sessionStorage !== "undefined") stores.push(sessionStorage);
  }
  return stores;
};

export const getStorageItem = (key) => {
  if (!key) return null;
  for (const storage of storageSources()) {
    try {
      const value = storage.getItem(key);
      if (value != null) return value;
    } catch (_) {}
  }
  return null;
};

export const clearAuthStorage = () => {
  const keys = [
    "authToken",
    "isAuthenticated",
    "userEmail",
    "rememberMe",
    "rememberedEmail",
    "userId",
    "userprofile",
    "profile_userprofile",
  ];
  for (const storage of storageSources()) {
    for (const key of keys) {
      try {
        storage.removeItem(key);
      } catch (_) {}
    }
  }
};

export const getAuthToken = () => getStorageItem("authToken");

export const getCachedUserProfile = () => {
  const raw =
    getStorageItem("userprofile") || getStorageItem("profile_userprofile");
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (_) {
    return null;
  }
};

export const parseUserId = (candidate) => {
  const values = [
    candidate?.user?.id,
    candidate?.profile?.user?.id,
    candidate?.profile?.id,
    candidate?.profile_id,
    candidate?.id,
    candidate?.userId,
  ];
  for (const val of values) {
    const str = val != null ? String(val).trim() : "";
    if (!str) continue;
    if (/^\d+$/.test(str)) return str;
  }
  return null;
};

export const getCurrentUserId = () => {
  const cached = getCachedUserProfile();
  const fromProfile = parseUserId(cached);
  if (fromProfile) return fromProfile;

  const stored = getStorageItem("userId");
  const numeric = Number(stored);
  return Number.isFinite(numeric) && numeric > 0 ? String(numeric) : null;
};

export const getCachedUserBundle = () => {
  const cached = getCachedUserProfile();
  if (!cached) return null;
  const profile = cached?.profile ? cached.profile : cached;
  const user = cached?.user || profile?.user || null;
  return { cached, profile, user };
};
